
import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare let ko: any;

export default class sensAI_vault_template extends vnTemplate {


    protected buildViewModel() {
        let self = this;

        return {
            summaryReturned: ko.observable(false),
            similarArticlesReturned: ko.observable(false),
            systemPrompt: ko.observable(""),
            userQuery: ko.observable(""),
            dataQuery: ko.observable(""),
            dataQueryResponse: ko.observable(""),
            temperature: ko.observable(0.5),
            summary: ko.observable(""),
            articles: ko.observable(""),
            imagePickerTarget: ko.observable(null),
            chatHistory: ko.observableArray([]),
            queryData: ko.observableArray([]),
            queryDataFormatted: ko.observableArray([]),
            sessionId: ko.observable(""),
            isChatDisabled: ko.observable(false),
            valnetImageData: ko.observable([]),
            //idVignette: this.tagPicker.tagEdit.getTemplateViewModel().idVignette,
            onClickQuickPrompt: function (data, event) {
                self.onClickQuickPrompt(data, event);
            },
            onClickSummarize: function (data, event) {
                self.onClickSummarize(data, event);
            },
            onClickSimilarArticles: function (data, event) {
                self.initiateSensaiChat(null);
                //this.hideHistoryTitle();
                const textarea = document.querySelector('.sensai-vault-user-query textarea') as HTMLTextAreaElement;
                if (textarea) {
                    textarea.style.height = "auto";
                }
                // Add the 'clicked' class to the container
                const container = document.querySelector('.sensai-vault-user-query-container');
                if (container) {
                    container.classList.add('clicked');
                }
            },
            onClickAnalyzeData: function (data, event) {
                self.onClickAnalyzeData();
            },
            onEnterKey: function (data, event) {
                if (event.keyCode === 13 && !event.shiftKey) {
                    self.initiateSensaiChat(event.target.value);
                    //event.target.value = "";
                    //this.hideHistoryTitle();
                    event.target.style.height = "auto";
                    // Add the 'clicked' class to the container
                    const container = document.querySelector('.sensai-vault-user-query-container');
                    if (container) {
                        container.classList.add('clicked');
                    }
                    return false;
                }
                return true;
            },
            onDataEnterKey: function (data, event) {
                if (event.keyCode === 13 && !event.shiftKey && event.target.value != "") {
                    self.caller.analyzeData(event.target.value);
                }
                return true;
            },
            hideHistoryTitle: function () {
                const historyTitle = document.querySelector('.history-title-above');
                if (historyTitle) {
                    historyTitle.classList.add('hidden');
                } else {
                    console.error("Element with class 'history-title-above' not found.");
                }
            },
            onClickClearChatHistory: function (data, event) {
                self.clearChatHistory();
            },
            onClickCancelRequest: function (data, event) {
                self.cancelRequest();
            },
            onClickNewTab: function(data, event){
                self.onClickNewTab(data, event);
            },

            copyPermalink: function (data, event) {
                self.copyPermalink(data, event);
            },


        };
    }

    protected initPartial() {

    }

    protected getTemplateName(): string {
        return "sensAI_vault_template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected getTemplateHtml(): string {
        return /*html*/ `
            <style>
              .hidden {
                    display: none;
                }
            </style>
            <div class="form-body sensai-vault-form-body">
                <h2 class="sensai-title">
                    <span class="sens">Sens</span><span class="ai">AI</span>
                </h2>

                <div class="form-group seo-description sensai-vault-form-body">
                    <h3 class="history-title-above">Audience Value Report</h3>
                    <div class="sensai-vault-user-query-container" id="user-query-container" style="display: grid;">
                        <div class="sensai-vault-user-query-wrapper">
                            <div class="sensai-vault-user-query">
                                <textarea oninput='this.style.height = "";this.style.height = this.scrollHeight + 3 + "px"' placeholder="Enter your database prompt" rows="3" data-bind="disable: isChatDisabled, value: userQuery, event: { keydown: onEnterKey }"></textarea>
                            </div>
                            <div class="sensai-vault-user-query-chat-container">
                                <div class="actions-btn-container">
                                    <div class="sensai-vault-clear-chat-container">
                                        <button tooltip="Cancel request" class="btn clear-chat-btn" type="button" data-bind="disable: !isChatDisabled(), event: {click: onClickCancelRequest}"><span class="icon i-notice-error"></span></button>
                                    </div>
                                    <div class="sensai-vault-submit-container">
                                        <button tooltip="Submit your prompt" class="chat-send-btn" type="button" data-bind="disable: isChatDisabled, event: {click: onClickSimilarArticles}">
                                        <!--<span class="icon i-send"></span>-->
                                            <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 449 448">
                                                <defs><style>.st0{fill:#fff;}</style></defs>
                                                <path class="st0" d="M441,2.8c5.2,3.8,7.8,9.8,6.8,16l-64,384c-.8,4.8-3.8,8.8-8,11.2-2.2,1.2-5,2-7.8,2s-4-.5-6-1.2l-113.2-46.2-60.5,73.8c-3,3.8-7.5,5.8-12.2,5.8s-3.8-.2-5.5-1c-6.2-2.2-10.5-8.2-10.5-15v-87.2L376,80,108.8,311.2l-98.8-40.5c-5.8-2.2-9.5-7.5-10-13.8-.2-6,2.8-11.8,8-14.8L424,2.2c2.5-1.5,5.2-2.2,8-2.2s6.5,1,9,2.8Z"/>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="history" id="history" data-bind="foreach: chatHistory">
                        <!-- ko if: ($data.role === 'user') -->
                            <div data-bind="text: $data.content, class: $data.role"></div>
                        <!-- /ko -->
                        <!-- ko if: ($data.role === 'system') -->
                            <div data-bind="html: $data.content, class: $data.role"></div>
                        <!-- /ko -->
                    </div>
                </div>
            </div>
            <div id="content-wrapper" data-bind="visible: queryData() && queryData().length > 0">
                <div id="topPerformingArticles" class="containerTopPerformingArticles">
                    <div class="w-list-results" data-bind="html: queryDataFormatted">

                    </div>
                </div>
            </div>
            <div class="form-body sensai-vault-form-body" data-bind="visible: queryData() && queryData().length > 0">
                <div class="form-group seo-description sensai-vault-form-body">
                    <div class="sensai-vault-user-query-container" id="db-query-container" style="display: grid;">
                        <div class="sensai-vault-user-query-wrapper">
                            <div class="sensai-vault-user-query">
                                <textarea oninput='this.style.height = "";this.style.height = this.scrollHeight + 3 + "px"' placeholder="Enter your data query" rows="3" data-bind="disable: isChatDisabled, value: dataQuery, event: { keydown: onDataEnterKey }"></textarea>
                            </div>
                            <div class="sensai-vault-user-query-chat-container">
                                <div class="actions-btn-container">
                                    <div class="sensai-vault-submit-container">
                                        <button tooltip="Submit your prompt" class="chat-send-btn" type="button" data-bind="disable: isChatDisabled, event: {click: onClickAnalyzeData}">
                                        <!--<span class="icon i-send"></span>-->
                                            <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 449 448">
                                                <defs><style>.st0{fill:#fff;}</style></defs>
                                                <path class="st0" d="M441,2.8c5.2,3.8,7.8,9.8,6.8,16l-64,384c-.8,4.8-3.8,8.8-8,11.2-2.2,1.2-5,2-7.8,2s-4-.5-6-1.2l-113.2-46.2-60.5,73.8c-3,3.8-7.5,5.8-12.2,5.8s-3.8-.2-5.5-1c-6.2-2.2-10.5-8.2-10.5-15v-87.2L376,80,108.8,311.2l-98.8-40.5c-5.8-2.2-9.5-7.5-10-13.8-.2-6,2.8-11.8,8-14.8L424,2.2c2.5-1.5,5.2-2.2,8-2.2s6.5,1,9,2.8Z"/>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="history" id="history-2">
                        <div data-bind="html: dataQueryResponse" class="system"></div>
                    </div>
                </div>
            </div>
        `;
    }

    private onClickSummarize(data, event) {
        this.caller.summarizeArticle();
    }

    private initiateSensaiChat(query, isQuickPrompt = false) {
        if (query === null) {
            query = this.getTemplateViewModel().userQuery();
        }

        if (query!== "") {
            this.clearChatHistory();
            this.getTemplateViewModel().queryDataFormatted([]);
            this.getTemplateViewModel().queryData([]);
            //this.addToChatHistory(query, "user");
            this.caller.initiateSensaiChat(query, isQuickPrompt);
            //this.getTemplateViewModel().userQuery("");
        }
    }

    private onClickAnalyzeData() {
        let dataQuery = this.getTemplateViewModel().dataQuery();

        this.caller.analyzeData(dataQuery);
    }

    private setUserQuery(query) {
        this.getTemplateViewModel().userQuery(query);
    }

    public setQueryData(queryData) {
        this.getTemplateViewModel().queryData(queryData);
    }

    public setQueryDataFormatted(queryData) {
        this.getTemplateViewModel().queryDataFormatted(queryData);
    }

    public setDataQueryResponse(response) {
        this.getTemplateViewModel().dataQueryResponse(response);
    }

    public addToChatHistory(historyItem, type) {
        let chatHistory = this.getTemplateViewModel().chatHistory();
        chatHistory.push({ content: historyItem, role: type});

        this.getTemplateViewModel().chatHistory();
        this.getTemplateViewModel().chatHistory(chatHistory);

        if(type === "system" ) {
            if(historyItem.includes("onClickImage")) {

                let galleryElements = document.querySelectorAll('.image-gallery');
                galleryElements.forEach(galleryElement => {
                    if (!galleryElement.querySelector('[data-bind]') || !ko.dataFor(galleryElement.querySelector('[data-bind]'))) {
                        ko.applyBindingsToDescendants(this.getTemplateViewModel(), galleryElement);
                    }
                });
            }else if (historyItem.includes("editArticleElement") || historyItem.includes("copyPermalink")) {
                let articleElements = document.querySelectorAll('.emaki-article-container');
                articleElements.forEach(articleElement => {
                    if (!articleElement.querySelector('[data-bind]') || !ko.dataFor(articleElement.querySelector('[data-bind]'))) {
                        ko.applyBindingsToDescendants(this.getTemplateViewModel(), articleElement);
                    }
                })

            }else if (historyItem.includes("emaki-displayCard tag") && historyItem.includes("onClickTag")) {
                let tagElements = document.querySelectorAll('.emaki-displayCard.tag');
                tagElements.forEach(tagElement => {
                    if (!tagElement.querySelector('[data-bind]') || !ko.dataFor(tagElement.querySelector('[data-bind]'))) {
                        ko.applyBindingsToDescendants(this.getTemplateViewModel(), tagElement);
                    }
                })
            }

        }
        setTimeout(() => {
            const historyContainer = document.getElementById('history');
            const lastChild = historyContainer.lastElementChild;
            if (lastChild) {
                lastChild.scrollIntoView({ behavior: 'smooth', block: 'end' });
            }
        }, 0);
    }

    public clearChatHistory(){
        this.getTemplateViewModel().chatHistory([]);
    }

    public cancelRequest(){
        this.caller.cancelRequest();
    }


    public onClickNewTab(data, event) {
        //data.url = data.url.replace("https://", "");
        const imgElement = event.target.closest("div").querySelector("img"); // Find the image in the same div
        if (!imgElement) {
            console.error("No image found to open in new tab.");
            return;
        }

        const imageUrl = imgElement.src;
        let cleanUrl = imageUrl.split('?')[0];
        window.open(cleanUrl, "_blank");
    }

    private onClickQuickPrompt(data, event) {
        //Clear chat history
        this.initiateSensaiChat(data, true);
        this.getTemplateViewModel().hideHistoryTitle();
        const textarea = document.querySelector('.sensai-vault-user-query textarea') as HTMLTextAreaElement;
        if (textarea) {
            textarea.style.height = "auto";
        }
        // Add the 'clicked' class to the container
        const container = document.querySelector('.sensai-vault-user-query-container');
        if (container) {
            container.classList.add('clicked');
        }
    }

    public copyPermalink(data, event) {
        const articleElement = event.target.closest(".emaki-article-container").querySelector(".emaki-article-card");

        if (!articleElement) {
            console.error("No article element found.");
            return;
        }

        const permalink = articleElement.getAttribute("data-permalink");

        if (!permalink) {
            console.error("No permalink found.");
            return;
        }

        // Create a temporary input field for copying
        const tempInput = document.createElement("textarea");
        tempInput.value = permalink;
        document.body.appendChild(tempInput);

        // Select and copy the text
        tempInput.select();
        document.execCommand("copy");

        // Remove the temporary input field
        document.body.removeChild(tempInput);
    }



    // public initTagPickerCkEditors(): void{

    //     this.tagPicker.initializeCkEditors();
    // }


}


// WEBPACK FOOTER //
// ./js/components/templates/sensAI_vault_template.ts